import BaseCollectiveLogListItem from './BaseCollectiveLogListItem'
import { ICollectiveLogListItemProps } from './common'

const CollectiveLogDataOnProposalRequireVoteSignatureChanged: React.FC<
  ICollectiveLogListItemProps<'CollectiveLogDataOnQuorumNeededInPercentageChanged'>
> = ({ bundledCollectiveLog, isLast }) => (
  <BaseCollectiveLogListItem
    bundle={bundledCollectiveLog}
    isLast={isLast}
    summaryActionText={`Setting "Quorom Percentage" was changed ${
      bundledCollectiveLog.logs.length === 1
        ? `to ${bundledCollectiveLog.logs[0].data.quorumNeededInPercentage}`
        : ''
    }`}
    hideSummaryActors
    detailsActionText={log =>
      `Quorom Percentage needed for proposal to pass was changed to ${log.data.quorumNeededInPercentage}`
    }
  />
)

export default CollectiveLogDataOnProposalRequireVoteSignatureChanged
